import { Icon } from './Icon';

/**
 * "On the stand" badge (R11 #3 — showcase-conversation-synergy.md §6 #5, client-scenarios.md S2
 * beat 4). Marks a piece that is physically on the booth stand at this event (the exhibited set;
 * `on_stand`/`onStand` on the product payload).
 *
 * Design-language treatment (design-language.md §8, §10): a quiet hairline + brass marker, NOT a
 * loud coloured pill. Warm-metallic-gallery: brass accent used sparingly as the through-line;
 * the imagery is the hero and the UI recedes. Two placements:
 *   - `overlay`  (default): floats on a product image (browse grid, detail) — frosted, hairline.
 *   - `inline`:  sits in a row of metadata (S6 order-review lines) — no background, just the mark.
 *
 * Tokens only, day+night aware, no motion (a static marker; nothing to animate).
 */
export function OnStandBadge({
  variant = 'overlay',
  className = '',
}: {
  variant?: 'overlay' | 'inline';
  className?: string;
}) {
  if (variant === 'inline') {
    return (
      <span
        data-testid="on-stand-badge"
        className={`inline-flex items-center gap-1 text-[11px] font-medium tracking-wide text-brass ${className}`}
      >
        <Icon name="check" size={11} />
        On the stand
      </span>
    );
  }
  return (
    <span
      data-testid="on-stand-badge"
      className={`inline-flex items-center gap-1 rounded-full bg-canvas/70 px-2 py-0.5 text-[10px] font-medium tracking-wide text-brass ring-1 ring-brass/30 backdrop-blur-sm ${className}`}
    >
      <Icon name="check" size={10} />
      On the stand
    </span>
  );
}
